<template>
    <div class="home-wrapper">
        <div @click="eventGetPdf()" class="down-pdf">
            <icon name="icon-PDF" color="#5297CB" class="icon" size="32"></icon>
        </div>
        <div class="home" id="pdfDom">
            <div class="banner">
                <div class="banner-info">
                    <div class="info-me">
                        <span class="my-name">{{user_info.name}}</span>
                        <span class="my-job-desc">{{user_info.job_name}}</span>
                    </div>
                    <div class="normal-info">
                        <div class="info-line">
                            <icon name="icon-xingbie" color="#fff" class="icon"></icon>
                            <span>{{user_info.sex}}</span>
                            <icon name="icon-shengri" color="#fff" class="icon"></icon>
                            <span>{{user_info.birthday}}</span>
                            <icon name="icon-iconset0111" color="#fff" class="icon"></icon>
                            <span>{{user_info.birthplace}}</span>
                            <icon name="icon-address" color="#fff" class="icon"></icon>
                            <span>{{user_info.address}}</span>
                            <icon name="icon-shu" color="#fff" class="icon"></icon>
                            <span>{{user_info.education}}</span>
                        </div>
                        <div class="info-line">
                            <icon name="icon-gongzuojingyan" color="#fff" class="icon"></icon>
                            <span>{{user_info.year}}</span>
                            <icon name="icon-shouji" color="#fff" class="icon"></icon>
                            <span>{{user_info.mobile}}</span>
                        </div>
                        <div class="info-line">
                            <icon name="icon-youjian3" color="#fff" class="icon"></icon>
                            <span>{{user_info.email}}</span>
                        </div>
                    </div>
                </div>
                <div class="banner-avatar">
                    <img src="@/assets/xkh.jpg" alt=""/>
                </div>
            </div>
            <div class="content">
                <home-content :content="content" v-for="(content, index) in contents" :key="index"></home-content>
            </div>
        </div>
    </div>
</template>

<script>
    import HomeContent from './HomeContent.vue'
    import {baseUrl} from '@/server/api'

    export default {
        name: 'home',
        components: {
            HomeContent
        },
        data() {
            return {
                user_info: {},
                contents: [],
                pdfTitle: ''
            };
        },
        created() {
            this.requestGetDetail();
        },
        methods: {
            async requestGetDetail() {
                let {id='000'} = this.$route.query;
                this.$loading();
                const {data: user} = await this.$a('get', baseUrl('user'),{id});
                this.user_info = user;
                // console.log('user....',user);

                const {data} = await this.$a('get', './home.json');
                const {contents} = data;
                this.contents = contents;
                // this.user_info = user_info;
                this.$nextTick(()=>{
                    this.$loading(false);
                });
            },
            eventGetPdf(){
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
                this.pdfTitle = `邢凯航-前端架构-${new Date().format('yyyy-MM-dd')}`;
                this.getPdf();
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "@/sass/mixin.scss";
@import "@/sass/reset.scss";
    .down-pdf{
        position: fixed;
        right: 50%;
        margin-right: -580px;
        bottom: 30px;
        z-index: 2;
    }
    @media (max-width: 800px) {
        .down-pdf{
            right: 20px;
            margin: 0;
        }
    }
    .home {
        width: 1200px;
        margin: 0 auto;
        background: $color_f;
        box-shadow: 4px 4px 12px 1px $color_9;
        padding-bottom: 100px;
        box-sizing: border-box;
        .page-load {
            width: 100%;
            height: 8px;
            background: $color_a;
        }
        .banner {
            position: relative;
            .banner-info {
                color: $color_f;
                width: 780px;
                background: $color_a;
                height: 270px;
                box-sizing: border-box;
                padding: 20px 0 15px 60px;
                position: relative;
                &:after {
                    content: '';
                    display: block;
                    position: absolute;
                    right: -99px;
                    bottom: 0;
                    width: 0;
                    height: 0;
                    border-top: 271px solid $color_a; //100px 控制向下延伸长
                    border-right: 100px solid transparent; //100px 控制向右延伸长
                }
                .info-me {
                    line-height: 70px;
                    .my-name {
                        font-size: 45px;
                    }
                    .my-job-desc {
                        margin-left: 30px;
                        font-size: 30px;
                    }
                }
                .normal-info {
                    .info-line {
                        line-height: 44px;
                        .icon {
                            &:not(:first-child) {
                                margin-left: 60px;
                            }
                        }
                        span {
                            font-size: 22px;
                            margin-left: 10px;
                        }
                    }
                }
            }
            .banner-avatar {
                position: absolute;
                right: 100px;
                top: 50%;
                transform: translateY(-48%);
                width: 200px;
                height: 200px;
                border-radius: 200px;
                background: #eeeeee;
                overflow: hidden;
                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .content {
            padding: 0 68px;
            width: 100%;
            box-sizing: border-box;
        }
    }
</style>
